import { triggerEvent } from '../lib/helper';
import { getClosestByClass } from '../lib/helper.js';

/**
 * Handles a tc-tabs element.
 * @type {Class}
 */
export default class Tabs {

  constructor(el) {

    // the wrapper-element for the tab-content and the tc-tab-trigger elements
    this.el = el;
    // reference for TabSelector
    this.el._instanceRef = this;
    this.tabIDs = [];
    this.tabContents = [];
    this.activeTrigger = null;
    this.activeTabContent = null;
    this.onlySelectorControl = (this.el.classList.contains('is-select-nav-tab')) ? true : false;
    this.isQuickviewTab = false;
    this.quickViewId = '';

    // get all triggers in one array
    this.triggers = [].slice.call(this.el.querySelectorAll('.tc-tab-trigger'));

    if (!this.triggers.length && !this.onlySelectorControl) {

      return;
    }

    if (getClosestByClass(this.el, 'quickview-wrapper')) {

      this.isQuickviewTab = true;
      if (getClosestByClass(this.el, 'overlay-content-wrapper')) {

        this.quickViewId = getClosestByClass(this.el, 'overlay-content-wrapper').id;
      }
    }

    if (this.onlySelectorControl) {

      this.prepareTriggersWithoutTabs();
    } else {

      this.prepareTriggersWithTabs();
    }

    this.prepareTabContents();

  }

  prepareTriggersWithoutTabs() {

    this.select = this.el.querySelector('.tab-header select');

    [].slice.call(this.select.options).map((trigger, index) => {

      this.tabIDs.push(trigger.value);

      return trigger;
    });

  }

  prepareTriggersWithTabs() {

    this.triggers.map(trigger => {

      if (trigger.classList.contains('active')) {

        this.activeTrigger = trigger;
      }

      this.tabIDs.push(trigger.getAttribute('data-tab-id'));
      trigger.addEventListener('click', e => {

        e.preventDefault();
        this.onClick(trigger);
      });

      return trigger;
    });
  }

  prepareTabContents() {

    this.tabIDs.map(id => {

      const el = this.el.querySelector('[data-id="' + id + '"]');

      if (el) {
        if (el.classList.contains('active')) {

          this.activeTabContent = el;
        }

        this.tabContents[id] = el;
      }

      return id;
    });
  }

  onClick(target) {

    if (!target) {

      return;
    }

    let targetID;

    if (this.onlySelectorControl) {

      targetID = target.value;
    } else {

      targetID = target.getAttribute('data-tab-id');
    }

    if (!targetID) {

      return;
    }

    if (!this.onlySelectorControl) {

      if (this.activeTrigger) {

        this.activeTrigger.classList.remove('active');
      }

      this.activeTrigger = target;
      target.classList.add('active');
    }

    this.toggle(targetID);
  }

  toggle(targetID) {

    if (this.activeTabContent) {

      this.activeTabContent.classList.remove('active');
    }

    this.tabContents[targetID].classList.add('active');
    this.activeTabContent = this.tabContents[targetID];

    triggerEvent(document, 'tc-tab-change');

    if (!this.onlySelectorControl) {

      triggerEvent(this.el, 'tabChange');
    }

    if (this.isQuickviewTab) {
      if (this.quickViewId) {

        triggerEvent(document, 'quickview-tab-change' + '#' + this.quickViewId);
      } else {

        triggerEvent(document, 'quickview-tab-change');
      }
    }
  }
}
